<template>

  <div>


    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner
            :animation-duration="1000"
            :size="100"
            :color="'#0e96b1'"
        />
      </div>

      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>{{ $t('Show') }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ $t('entries') }}</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
              
                v-debounce:500ms="debounceSearch" 
                class="d-inline-block mr-1"
                :placeholder="$t('Search...')"
              />
              <b-button v-if="hasPermission('alerts.create')" variant="primary" :to="{name: 'alerts.create'}">
                <span class="text-nowrap"> {{ $t('Create Alert')}}</span>
              </b-button>

              

            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refDeviceListTable"
        class="position-relative"
        :items="fetchList"
        responsive
        :fields="tableColumns.map(i=>({key:i.key,label:$t(i.label)}))"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('No matching records found')"
        :sort-desc.sync="isSortDirDesc"
      >


        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown class="actionIcon" variant="link" no-caret :right="$store.state.appConfig.isRTL">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="{ name: 'alerts.edit', params: { id: data.item.id } }"
                             v-if="$store.state.auth.userData.permissions.includes('alerts.edit')">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Edit') }}</span>
            </b-dropdown-item>
            <b-dropdown-item @click="removeAlert(data.item.id)"
                             v-if="$store.state.auth.userData.permissions.includes('alerts.destroy')" >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">{{ $t('Delete')}}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} {{$t('entries')}}</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination v-model="currentPage" :total-rows="totalItems" :per-page="perPage"
              first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18"/>
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18"/>
              </template>
            </b-pagination>
          </b-col>

        </b-row>
      </div>
    </b-card>

  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, VBModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'

import useAlertsList from '@/views/modules/alerts/alerts-list/useAlertsList'
import { OrbitSpinner } from 'epic-spinners'
import notificationStoreModule from '../notificationStoreModule'
import { hasPermission } from '@/auth/utils'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
   
    OrbitSpinner,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },

  directives: {
    'b-modal': VBModal,
  },

  setup(props, { root}) {



    const debounceSearch =(val)=>{
      searchQuery.value=val
   
}
 

    const importFileInput = ref(null)

    const DEVICE_APP_STORE_MODULE_NAME = 'app-alert'

    // Register module
    if (!store.hasModule(DEVICE_APP_STORE_MODULE_NAME))
      store.registerModule(DEVICE_APP_STORE_MODULE_NAME, notificationStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(DEVICE_APP_STORE_MODULE_NAME))
        store.unregisterModule(DEVICE_APP_STORE_MODULE_NAME)
    })


    

    const removeAlert = id => {

      root.$swal({
        title: root.$i18n.t("Are You Sure"),
        text: root.$i18n.t("Do you want to delete this device?"),
        showCancelButton: true,
        confirmButtonText: root.$i18n.t('Delete'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          requestStatus.value = true
          store.dispatch('app-alert/deleteAlert', id)
              .then(_ => {
                refetchData()
                root.$bvToast.toast(
                    root.$i18n.t('Alert Deleted Successfully'), {
                      title: root.$i18n.t('Success'),
                      variant: 'success',
                      solid: true, })
              }).catch(reason => console.log(reason))
        }
      })
    }


    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDeviceListTable,
      refetchData,
      

     

      // UI
      requestStatus,

    } = useAlertsList()

    return {
      importFileInput,
      
      removeAlert,
      requestStatus,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDeviceListTable,
      refetchData,


      // Filter
      avatarText,
   


      hasPermission,
      debounceSearch
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.actionIcon > button {
  padding: 0;
}
</style>
